<template>
  <div class="tx-Taxons_Wrapper">
    <button
      @click="isOpen = !isOpen"
      class="tx-Taxons_Header btn btn-reset w-100 text-left p-0 d-flex justify-content-between align-items-center"
    >
      <div class="tx-Taxons_HeaderText flex-grow-1 pr-2">{{ title }}</div>
      <ChevronDown :class="isOpen ? 'rotate-180' : ''" class="expand-icon svg-16" />
    </button>
    <transition name="fade">
      <div v-if="isOpen">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import ChevronDown from "../../icons/atalanda/chevron-down.svg";

export default {
  name: "FilterWrapper",
  components: {
    ChevronDown,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    initialOpen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: this.initialOpen,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.expand-icon {
  transition: transform $transition-duration;
}

.rotate-180 {
  transform: rotate(180deg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration-short;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
